import { defineComponent as _defineComponent } from 'vue'
import KinzaBpsBanner from "@/views/pages/main/KinzaBpsBanner.vue";
import ConversionClubBpsBanner from "@/views/pages/main/ConversionClubBpsBanner.vue";
import TrustpilotBpsBanner from "@/views/pages/main/TrustpilotBpsBanner.vue";
import PartnerkinBpsBanner from "@/views/pages/main/PartnerkinBpsBanner.vue";
import MacBfsBanner from "@/views/pages/main/MacBfsBanner.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'IntroAchievements',
  setup(__props) {



return { __sfc: true,KinzaBpsBanner, ConversionClubBpsBanner, TrustpilotBpsBanner, PartnerkinBpsBanner, MacBfsBanner }
}

})